import capitalize from "lodash/capitalize";
import { t } from "@/i18n-js/instance";
import { isPlanBasic, isPlanEnterprise } from "@/react/helpers/planHelpers";
import { SanitizeHTMLString } from "@circle-react/components/shared/uikit/SanitizeContent";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const GrandfatheredDowngradeWarning = ({ currentPlan }: any) => {
  const getDowngradeMessageKey = () => {
    if (
      isPlanBasic(currentPlan.tier) ||
      (isPlanEnterprise(currentPlan.tier) && !currentPlan.public)
    ) {
      return "legacy_plan_downgrade_warning";
    }

    if (currentPlan.show_pro_grandfathered_for_courses) {
      return "professional_downgrade_warning";
    }
    return "";
  };

  const downgradeMessageText = getDowngradeMessageKey();

  return (
    <WarningWrapper>
      <Typography.BodyMd color="text-default">
        <SanitizeHTMLString
          content={t(downgradeMessageText, {
            name: capitalize(currentPlan.tier),
            price: currentPlan.base_amount,
            interval: currentPlan.interval,
          })}
        />
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
